var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "container-fluid",
        attrs: { "data-feedback-code-mirror": "" },
      },
      [
        _c("textarea", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.ensureTenLinesInSolution,
              expression: "ensureTenLinesInSolution",
            },
          ],
          ref: "cm-editor",
          domProps: { value: _vm.ensureTenLinesInSolution },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.ensureTenLinesInSolution = $event.target.value
            },
          },
        }),
      ]
    ),
    !_vm.readonly
      ? _c("div", { staticClass: "container-fluid text-right py-2" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary mx-2",
              attrs: {
                "data-button-send-feedback": "",
                disabled: !_vm.numberOfComments,
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.saveFeedbackList.apply(null, arguments)
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.T.submissionSendFeedback) + " ")]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }